/* Header grubu: duyuru çubuğu, mega menü, anlık arama, mobil menü çekmecesi */
(() => {
  const DESKTOP = window.matchMedia('(min-width: 990px)');
  const REDUCE_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');
  const RECENT_KEY = 'cpl:recent-searches';
  const RECENT_MAX = 5;

  const storage = {
    get(key, fallback) {
      try {
        const v = window.localStorage.getItem(key);
        return v ? JSON.parse(v) : fallback;
      } catch (e) {
        return fallback;
      }
    },
    set(key, value) {
      try {
        window.localStorage.setItem(key, JSON.stringify(value));
      } catch (e) {
        /* depolama kapalıysa sessiz geç */
      }
    },
  };

  /* Sticky header yüksekliğini :root'a yaz */
  let headerObserver;
  const initHeaderHeight = () => {
    const header = document.querySelector('[data-header]');
    if (headerObserver) headerObserver.disconnect();
    if (!header) return;
    const sticky = header.hasAttribute('data-sticky');
    const set = () =>
      document.documentElement.style.setProperty('--header-height', sticky ? `${header.offsetHeight}px` : '0px');
    set();
    if ('ResizeObserver' in window) {
      headerObserver = new ResizeObserver(set);
      headerObserver.observe(header);
    }
  };
  initHeaderHeight();
  document.addEventListener('shopify:section:load', initHeaderHeight);

  /* Sepet: cart-drawer varsa çekmeceyi aç, yoksa /cart bağlantısı çalışsın */
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-cart-open]');
    if (!link) return;
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      e.preventDefault();
      drawer.open(link);
    }
  });

  /* Sepet sayacı: mobil rozet 0 iken gizli */
  if (window.CPL && CPL.subscribe) {
    CPL.subscribe(CPL.events.cartUpdate, ({ cart }) => {
      if (!cart) return;
      document.querySelectorAll('.header__cart-count').forEach((el) => el.classList.toggle('is-empty', cart.item_count === 0));
    });
  }

  /* Header arka planı (mega menü / arama açıkken) */
  const setOverlay = (header, key, on) => {
    if (!header) return;
    header._overlays = header._overlays || new Set();
    on ? header._overlays.add(key) : header._overlays.delete(key);
    header.classList.toggle('has-overlay', header._overlays.size > 0);
  };

  /* <announcement-bar> */
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-announcement-slide]'));
      this.live = this.querySelector('[data-announcement-slides]');
      this.index = 0;
      this.querySelector('[data-announcement-prev]')?.addEventListener('click', () => this.step(-1, true));
      this.querySelector('[data-announcement-next]')?.addEventListener('click', () => this.step(1, true));
      this.querySelector('[data-announcement-close]')?.addEventListener('click', () => this.close());

      const auto = this.dataset.autoRotate === 'true' && this.slides.length > 1 && !REDUCE_MOTION.matches;
      if (auto) {
        this.speed = Math.max(3, parseInt(this.dataset.speed, 10) || 5) * 1000;
        ['mouseenter', 'focusin'].forEach((ev) => this.addEventListener(ev, () => (this.paused = true)));
        this.addEventListener('mouseleave', () => (this.paused = false));
        this.addEventListener('focusout', (e) => {
          if (!this.contains(e.relatedTarget)) this.paused = false;
        });
        this.timer = setInterval(() => !this.paused && this.step(1), this.speed);
      }

      /* Tema düzenleyicide blok seçilince onu göster */
      this.addEventListener('shopify:block:select', (e) => {
        const i = this.slides.indexOf(e.target);
        if (i > -1) this.show(i);
        this.paused = true;
      });
      this.addEventListener('shopify:block:deselect', () => (this.paused = false));
    }
    disconnectedCallback() {
      clearInterval(this.timer);
    }
    step(dir, manual) {
      if (manual) {
        /* Kullanıcı etkileşiminden sonra otomatik geçiş durur, duyurular okunur */
        clearInterval(this.timer);
        this.live.setAttribute('aria-live', 'polite');
      }
      this.show((this.index + dir + this.slides.length) % this.slides.length);
    }
    show(i) {
      this.slides[this.index].hidden = true;
      this.index = i;
      this.slides[i].hidden = false;
    }
    close() {
      clearInterval(this.timer);
      try {
        sessionStorage.setItem('cpl:announcement-closed', '1');
      } catch (e) {
        /* sessiz geç */
      }
      (this.closest('.shopify-section') || this).hidden = true;
      document.querySelector('.header__logo')?.focus();
    }
  }
  customElements.define('announcement-bar', AnnouncementBar);

  /* <header-menu> — masaüstü mega menü: hover / focus / Esc */
  class HeaderMenu extends HTMLElement {
    connectedCallback() {
      this.header = this.closest('[data-header]');
      this.items = Array.from(this.querySelectorAll('[data-mega-item]'));
      this.current = null;

      this.items.forEach((li) => {
        const trigger = li.querySelector('[data-mega-trigger]');
        li.addEventListener('mouseenter', () => this.schedule(() => this.open(li), 60));
        li.addEventListener('mouseleave', () => this.schedule(() => this.close(), 150));
        trigger.addEventListener('focus', () => {
          if (this.skipFocus) return (this.skipFocus = false);
          this.open(li);
        });
        li.addEventListener('focusout', (e) => {
          if (!li.contains(e.relatedTarget) && this.current === li) this.close();
        });
        trigger.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown' && this.current === li) {
            e.preventDefault();
            li.querySelector('[data-mega-panel] a')?.focus();
          }
        });
      });

      /* Mega menüsüz öğeye geçince kapat */
      this.querySelectorAll('.header__nav-item:not([data-mega-item])').forEach((li) =>
        li.addEventListener('mouseenter', () => this.schedule(() => this.close(), 60))
      );

      this.onKeydown = (e) => {
        if (e.key !== 'Escape' || !this.current) return;
        const trigger = this.current.querySelector('[data-mega-trigger]');
        const hadFocus = this.current.contains(document.activeElement);
        this.close();
        if (hadFocus) {
          this.skipFocus = true;
          trigger.focus();
        }
      };
      document.addEventListener('keydown', this.onKeydown);

      this.backdrop = this.header?.querySelector('[data-header-backdrop]');
      this.onBackdrop = () => this.close();
      this.backdrop?.addEventListener('mouseenter', this.onBackdrop);
      this.backdrop?.addEventListener('click', this.onBackdrop);

      /* Tema düzenleyici: blok seçilince paneli aç */
      this.addEventListener('shopify:block:select', (e) => {
        const li = e.target.closest('[data-mega-item]');
        if (li) this.open(li);
      });
      this.addEventListener('shopify:block:deselect', () => this.close());
    }
    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      setOverlay(this.header, 'mega', false);
    }
    schedule(fn, wait) {
      clearTimeout(this.timer);
      this.timer = setTimeout(fn, wait);
    }
    open(li) {
      clearTimeout(this.timer);
      if (!DESKTOP.matches || this.current === li) return;
      if (this.current) this.toggleItem(this.current, false);
      this.current = li;
      this.toggleItem(li, true);
      setOverlay(this.header, 'mega', true);
      this.header?.querySelector('predictive-search')?.closePanel?.();
    }
    close() {
      clearTimeout(this.timer);
      if (!this.current) return;
      this.toggleItem(this.current, false);
      this.current = null;
      setOverlay(this.header, 'mega', false);
    }
    toggleItem(li, on) {
      li.classList.toggle('is-open', on);
      li.querySelector('[data-mega-trigger]')?.setAttribute('aria-expanded', String(on));
    }
  }
  customElements.define('header-menu', HeaderMenu);

  /* <predictive-search> — debounce'lu anlık arama, son/popüler aramalar, klavye gezinme */
  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.header = this.closest('[data-header]');
      this.form = this.querySelector('[data-search-form]');
      this.input = this.querySelector('input[type="search"]');
      this.panel = this.querySelector('[data-search-panel]');
      this.loading = this.querySelector('[data-search-loading]');
      this.emptyEl = this.querySelector('[data-search-empty]');
      this.resultsEl = this.querySelector('[data-search-results]');
      this.statusEl = this.querySelector('[data-search-status]');
      this.clearBtn = this.querySelector('[data-search-clear]');
      this.openers = Array.from(document.querySelectorAll(`[data-search-open][aria-controls="${this.id}"]`));
      this.cache = new Map();
      this.limit = 4;
      this.types = 'product,collection';
      this.placeholder = this.input.placeholder;

      this.debounced = CPL.debounce(() => this.search(), 300);
      this.input.addEventListener('input', () => {
        this.syncClear();
        if (!this.query()) {
          this.abort();
          this.showEmpty();
          return;
        }
        this.debounced();
      });
      this.input.addEventListener('focus', () => this.openPanel());
      this.input.addEventListener('pointerenter', () => this.loadEmpty(), { once: true });
      this.input.addEventListener('keydown', (e) => this.onKeydown(e));
      this.addEventListener('keydown', (e) => this.onEscape(e));
      this.form.addEventListener('submit', () => this.saveRecent(this.query()));

      this.clearBtn.addEventListener('click', () => {
        this.input.value = '';
        this.syncClear();
        this.abort();
        this.showEmpty();
        this.input.focus();
      });

      /* Panel içi tıklamalar */
      this.addEventListener('click', (e) => {
        const term = e.target.closest('[data-search-term]');
        const remove = e.target.closest('[data-remove-recent]');
        const result = e.target.closest('[data-search-results] a');
        if (remove) {
          e.preventDefault();
          this.removeRecent(remove.dataset.removeRecent);
        } else if (term) {
          e.preventDefault();
          this.input.value = term.dataset.searchTerm;
          this.syncClear();
          this.input.focus();
          this.search();
        } else if (result) {
          this.saveRecent(this.query());
        }
      });
      this.querySelectorAll('[data-search-close]').forEach((b) => b.addEventListener('click', () => this.closeMobile()));

      /* Masaüstü: dışarı tıklayınca / odak çıkınca kapat */
      this.onDocClick = (e) => {
        if (!DESKTOP.matches || this.panel.hidden) return;
        if (!this.contains(e.target)) this.closePanel();
      };
      document.addEventListener('click', this.onDocClick);
      this.addEventListener('focusout', (e) => {
        if (DESKTOP.matches && e.relatedTarget && !this.contains(e.relatedTarget)) this.closePanel();
      });

      /* Mobil açıcılar */
      this.onOpenerClick = (e) => this.openMobile(e.currentTarget);
      this.openers.forEach((b) => b.addEventListener('click', this.onOpenerClick));

      this.onBreakpoint = () => {
        if (this.classList.contains('is-open')) this.closeMobile(true);
        else this.closePanel();
      };
      DESKTOP.addEventListener('change', this.onBreakpoint);

      this.syncClear();
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      DESKTOP.removeEventListener('change', this.onBreakpoint);
      setOverlay(this.header, 'search', false);
    }

    query() {
      return this.input.value.trim();
    }
    syncClear() {
      this.clearBtn.hidden = !this.input.value.length;
    }
    abort() {
      this.controller?.abort();
    }

    /* Boş durum (son + popüler aramalar) predictive-search section'ından bir kez alınır */
    async loadEmpty() {
      if (this.emptyPromise) return this.emptyPromise;
      const root = window.Shopify?.routes?.root || '/';
      this.emptyPromise = fetch(`${root}?section_id=predictive-search`)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const empty = doc.querySelector('[data-predictive-empty]');
          if (!empty) return;
          this.limit = parseInt(empty.dataset.limit, 10) || 4;
          this.types = empty.dataset.types || this.types;
          this.emptyEl.replaceChildren(...empty.childNodes);
          this.renderRecent();
        })
        .catch(() => {
          this.emptyPromise = null;
        });
      return this.emptyPromise;
    }

    async openPanel() {
      if (!this.classList.contains('is-active')) {
        this.classList.add('is-active');
        if (DESKTOP.matches) {
          this.panel.hidden = false;
          this.input.setAttribute('aria-expanded', 'true');
          setOverlay(this.header, 'search', true);
          this.header?.querySelector('header-menu')?.close?.();
        }
      }
      if (this.query()) {
        if (this.resultsEl.hidden) this.search();
      } else {
        this.showEmpty();
      }
    }
    closePanel() {
      if (!this.classList.contains('is-active') && this.panel.hidden) return;
      this.classList.remove('is-active');
      if (DESKTOP.matches) this.panel.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
      setOverlay(this.header, 'search', false);
    }

    openMobile(opener) {
      if (DESKTOP.matches) {
        this.input.focus();
        return;
      }
      this.opener = opener;
      this.classList.add('is-open', 'is-active');
      this.panel.hidden = false;
      this.input.placeholder = this.input.dataset.placeholderMobile || this.placeholder;
      this.input.setAttribute('aria-expanded', 'true');
      this.openers.forEach((b) => b.setAttribute('aria-expanded', 'true'));
      document.body.classList.add('overflow-hidden');
      CPL.trapFocus(this, this.input);
      this.openPanel();
    }
    closeMobile(silent) {
      if (!this.classList.contains('is-open')) return this.closePanel();
      this.classList.remove('is-open', 'is-active');
      this.panel.hidden = true;
      this.input.placeholder = this.placeholder;
      this.input.setAttribute('aria-expanded', 'false');
      this.openers.forEach((b) => b.setAttribute('aria-expanded', 'false'));
      document.body.classList.remove('overflow-hidden');
      CPL.removeTrapFocus(silent ? null : this.opener);
    }

    showEmpty() {
      this.resultsEl.hidden = true;
      this.emptyEl.hidden = false;
      this.statusEl.textContent = '';
      this.input.removeAttribute('aria-activedescendant');
      this.loading.hidden = !!this.emptyEl.childElementCount;
      this.loadEmpty().then(() => {
        if (!this.query()) this.loading.hidden = true;
      });
      this.renderRecent();
    }

    async search() {
      const q = this.query();
      if (!q) return this.showEmpty();
      await this.loadEmpty();
      if (q !== this.query()) return;
      const key = q.toLowerCase();
      if (this.cache.has(key)) return this.renderResults(this.cache.get(key), q);

      this.abort();
      this.controller = new AbortController();
      this.setAttribute('aria-busy', 'true');
      const url =
        `${window.routes.predictive_search_url}?q=${encodeURIComponent(q)}` +
        `&section_id=predictive-search&resources[type]=${this.types}&resources[limit]=${this.limit}`;
      try {
        const res = await fetch(url, { signal: this.controller.signal });
        if (!res.ok) throw new Error(res.status);
        const html = await res.text();
        this.cache.set(key, html);
        if (q === this.query()) this.renderResults(html, q);
      } catch (e) {
        if (e.name !== 'AbortError') this.showEmpty();
      } finally {
        this.removeAttribute('aria-busy');
      }
    }

    renderResults(html, q) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const results = doc.querySelector('[data-predictive-results]');
      if (!results) return;
      this.resultsEl.replaceChildren(...results.childNodes);
      this.highlight(q);
      this.emptyEl.hidden = true;
      this.loading.hidden = true;
      this.resultsEl.hidden = false;
      this.selected = -1;
      this.input.removeAttribute('aria-activedescendant');
      const status = this.resultsEl.querySelector('[data-results-status]');
      this.statusEl.textContent = status ? status.textContent.trim() : '';
      if (DESKTOP.matches && this.classList.contains('is-active')) this.panel.hidden = false;
    }

    /* Eşleşen kısmı <mark> ile vurgula */
    highlight(q) {
      const needle = q.toLocaleLowerCase('tr');
      this.resultsEl.querySelectorAll('[data-highlight]').forEach((el) => {
        const text = el.textContent;
        const i = text.toLocaleLowerCase('tr').indexOf(needle);
        if (i < 0 || !needle) return;
        const mark = document.createElement('mark');
        mark.textContent = text.slice(i, i + q.length);
        el.replaceChildren(text.slice(0, i), mark, text.slice(i + q.length));
      });
    }

    options() {
      return Array.from(this.resultsEl.querySelectorAll('[role="option"]'));
    }
    onEscape(e) {
      if (e.key !== 'Escape') return;
      if (this.classList.contains('is-open')) {
        e.preventDefault();
        e.stopPropagation();
        this.closeMobile();
      } else if (this.classList.contains('is-active')) {
        e.preventDefault();
        e.stopPropagation();
        const inside = this.panel.contains(document.activeElement);
        this.closePanel();
        if (inside) {
          this.input.focus();
          this.closePanel();
        }
      }
    }
    onKeydown(e) {
      if (this.resultsEl.hidden) return;
      const opts = this.options();
      if (!opts.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        let next = this.selected + (e.key === 'ArrowDown' ? 1 : -1);
        if (next < -1) next = opts.length - 1;
        this.select(next, opts);
      } else if (e.key === 'Enter' && this.selected > -1 && opts[this.selected]) {
        e.preventDefault();
        this.saveRecent(this.query());
        opts[this.selected].querySelector('a')?.click();
      }
    }
    select(next, opts) {
      /* -1 = giriş alanı; son öğeden sonra başa döner */
      if (next >= opts.length) next = -1;
      opts.forEach((o, i) => o.setAttribute('aria-selected', String(i === next)));
      this.selected = next;
      if (next === -1) {
        this.input.removeAttribute('aria-activedescendant');
        return;
      }
      this.input.setAttribute('aria-activedescendant', opts[next].id);
      opts[next].scrollIntoView({ block: 'nearest' });
    }

    /* Son aramalar (localStorage) */
    getRecent() {
      const list = storage.get(RECENT_KEY, []);
      return Array.isArray(list) ? list.filter((x) => typeof x === 'string') : [];
    }
    saveRecent(q) {
      if (!q) return;
      const list = this.getRecent().filter((x) => x.toLowerCase() !== q.toLowerCase());
      list.unshift(q);
      storage.set(RECENT_KEY, list.slice(0, RECENT_MAX));
    }
    removeRecent(q) {
      storage.set(
        RECENT_KEY,
        this.getRecent().filter((x) => x !== q)
      );
      this.renderRecent();
      this.input.focus();
    }
    renderRecent() {
      const group = this.emptyEl.querySelector('[data-recent-group]');
      const list = this.emptyEl.querySelector('[data-recent-list]');
      const tpl = this.emptyEl.querySelector('[data-recent-template]');
      if (!group || !list || !tpl) return;
      const items = this.getRecent();
      list.replaceChildren(
        ...items.map((q) => {
          const li = tpl.content.firstElementChild.cloneNode(true);
          li.querySelector('[data-search-term]').dataset.searchTerm = q;
          li.querySelector('[data-recent-label]').textContent = q;
          li.querySelector('[data-remove-recent]').dataset.removeRecent = q;
          return li;
        })
      );
      group.hidden = !items.length;
    }
  }
  customElements.define('predictive-search', PredictiveSearch);

  /* <menu-drawer> — mobil iki seviyeli menü, odak tuzağı */
  class MenuDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.drawer__panel');
      this.main = this.querySelector('[data-menu-main]');
      this.openers = Array.from(document.querySelectorAll(`[aria-controls="${this.id}"]`));
      this.onOpenerClick = (e) => this.open(e.currentTarget);
      this.openers.forEach((b) => b.addEventListener('click', this.onOpenerClick));
      this.querySelectorAll('[data-drawer-close]').forEach((b) => b.addEventListener('click', () => this.close()));
      // Aynı sayfadaki bir bölüme giden bağlantı (ör. /#set): menüyü kapat ki bölüm görünsün
      this.querySelectorAll('[data-menu-close-on-click]').forEach((a) => a.addEventListener('click', () => this.close(true)));
      this.querySelectorAll('[data-submenu-open]').forEach((b) => b.addEventListener('click', () => this.openSub(b)));
      this.querySelectorAll('[data-submenu-back]').forEach((b) => b.addEventListener('click', () => this.closeSub()));
      this.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        e.stopPropagation();
        this.activeSub ? this.closeSub() : this.close();
      });
      this.onBreakpoint = () => DESKTOP.matches && this.close(true);
      DESKTOP.addEventListener('change', this.onBreakpoint);
    }
    disconnectedCallback() {
      DESKTOP.removeEventListener('change', this.onBreakpoint);
      if (this.classList.contains('is-open')) document.body.classList.remove('overflow-hidden');
    }
    get duration() {
      return REDUCE_MOTION.matches ? 0 : 300;
    }
    open(opener) {
      this.opener = opener;
      this.classList.add('is-open');
      this.openers.forEach((b) => b.setAttribute('aria-expanded', 'true'));
      document.body.classList.add('overflow-hidden');
      /* visibility geçişi bitince odakla */
      requestAnimationFrame(() => CPL.trapFocus(this.panel, this.querySelector('[data-drawer-close].icon-btn')));
    }
    close(silent) {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      this.openers.forEach((b) => b.setAttribute('aria-expanded', 'false'));
      document.body.classList.remove('overflow-hidden');
      CPL.removeTrapFocus(silent ? null : this.opener);
      setTimeout(() => this.resetSub(), this.duration);
    }
    openSub(button) {
      const sub = document.getElementById(button.getAttribute('aria-controls'));
      if (!sub) return;
      this.activeSub = sub;
      this.subOpener = button;
      button.setAttribute('aria-expanded', 'true');
      sub.hidden = false;
      sub.getBoundingClientRect(); /* geçiş için reflow */
      sub.classList.add('is-active');
      this.main.classList.add('is-behind');
      clearTimeout(this.subTimer);
      this.subTimer = setTimeout(() => {
        this.main.hidden = true;
        sub.querySelector('[data-submenu-back]')?.focus();
      }, this.duration);
    }
    closeSub() {
      const sub = this.activeSub;
      if (!sub) return;
      this.main.hidden = false;
      this.main.getBoundingClientRect();
      this.main.classList.remove('is-behind');
      sub.classList.remove('is-active');
      this.subOpener?.setAttribute('aria-expanded', 'false');
      this.subOpener?.focus();
      this.activeSub = null;
      clearTimeout(this.subTimer);
      this.subTimer = setTimeout(() => (sub.hidden = true), this.duration);
    }
    resetSub() {
      if (!this.activeSub) return;
      this.main.hidden = false;
      this.main.classList.remove('is-behind');
      this.activeSub.classList.remove('is-active');
      this.activeSub.hidden = true;
      this.subOpener?.setAttribute('aria-expanded', 'false');
      this.activeSub = null;
    }
  }
  customElements.define('menu-drawer', MenuDrawer);
})();
